import { Alert, Button, Modal, Spinner } from "react-bootstrap";
import { useState } from "react";

import AttemptsInputBoulder from "../../AttemptsInputBoulder";
import AttemptsInputSport from "../../AttemptsInputSport";
import { RouteCircle } from "../../RouteCircle";
import ScreenHeader from "../../ScreenHeader/ScreenHeader";
import useAttemptsScreen from "./useAttemptsScreen";
import Avatar from "../../Avatar";

export default function AttemptsScreen() {
  const {
    route,
    routeName,
    entry,
    isSubmitting,
    attempts,
    existingAttempts,
    setAttempts,
    setAttemptSingle,
    isTouched,
    setIsTouched,
    isDirty,
    onSave,
    onClear,
    onSkip,
    queuePosition,
    judgePermissions,
    competition,
    judgesByUUID,
  } = useAttemptsScreen({
    onSubmitError: () =>
      alert("There was a problem updating attempts. Please try again"),
  });

  const [showClearAttemptsConfirm, setShowClearAttemptsConfirm] =
    useState(false);
  return (
    <>
      <Modal show={showClearAttemptsConfirm}>
        <Modal.Header closeButton>Clear Attempts</Modal.Header>
        <Modal.Body>
          Are you sure you want to clear this competitor’s attempts on this
          route?
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-secondary"
            onClick={() => setShowClearAttemptsConfirm(false)}
          >
            Cancel
          </Button>
          <Button
            disabled={isSubmitting || !judgePermissions?.canClear}
            variant="danger"
            onClick={() => {
              setShowClearAttemptsConfirm(false);
              onClear();
            }}
          >
            Clear attempts
          </Button>
        </Modal.Footer>
      </Modal>
      <div style={{ height: "100vh" }} className="d-flex flex-column container">
        <ScreenHeader>
          Log attempts
          {routeName ? `: Route ${routeName}` : null}
        </ScreenHeader>
        <div
          className="flex-fill d-flex flex-column"
          style={{ paddingBottom: 100 }}
        >
          <div className="d-flex mb-3 align-items-end">
            <div className="d-flex flex-fill align-items-center">
              <Avatar user={entry?.user} size={40} />
              <div className="lh-1 ms-2">
                <div className="fw-bold mb-1">
                  {entry
                    ? `${entry.user.firstName} ${entry.user.lastName}`
                    : "-"}
                </div>
                <div className="small">
                  {entry ? entry.category?.name : "-"}
                </div>
              </div>
            </div>
            <div className="text-end">
              <label className="small text-muted lh-1">Route</label>
              <div className="d-flex align-items-center">
                <RouteCircle
                  className="me-2"
                  colors={[route?.colors || "#FFFFFF"]}
                />
                <h3 className="mb-0">{routeName || "-"}</h3>
              </div>
            </div>
          </div>
          {judgePermissions?.canAdd === false ? (
            <Alert variant="warning">
              You’re not assigned to judge this route, so you can’t make any
              changes on this screen.
            </Alert>
          ) : null}
          {judgePermissions?.canAdd &&
          existingAttempts?.length &&
          !judgePermissions.canModify ? (
            <Alert variant="warning">
              If you need to make changes to the attempts, please let the event
              staff know
            </Alert>
          ) : null}
          {route?.climbType === "BOULDER" ? (
            <AttemptsInputBoulder
              attempts={attempts}
              hardMaxAttemptsCount={competition?.settings?.maxAttemptsCount}
              existingAttempts={existingAttempts}
              onChange={setAttempts}
              isTouched={isTouched}
              onTouched={() => setIsTouched(true)}
              disabled={!attempts || isSubmitting || !judgePermissions?.canAdd}
              canModify={judgePermissions?.canModify}
              segmentsCount={route?.segmentsCount || 0}
              judgesByUUID={judgesByUUID}
            />
          ) : null}
          {route?.climbType === "SPORT" ? (
            <AttemptsInputSport
              attempt={attempts?.[0]}
              disabled={isSubmitting || !judgePermissions?.canAdd}
              onChange={setAttemptSingle}
              // canModify={judgePermissions?.canModify}
              maxSegmentsCount={route?.segmentsCount || 0}
            />
          ) : null}
          {isDirty ? (
            <div className="fixed-bottom m-2">
              <Button
                className="w-100"
                size="lg"
                disabled={isSubmitting}
                onClick={onSave}
              >
                {isSubmitting ? (
                  <Spinner animation="border" size="sm" className="me-2" />
                ) : null}
                Save
              </Button>
            </div>
          ) : (
            queuePosition !== -1 && (
              <div className="fixed-bottom m-2">
                <Button
                  className="w-100"
                  variant="outline-secondary"
                  size="lg"
                  onClick={onSkip}
                >
                  {isSubmitting ? (
                    <Spinner animation="border" size="sm" className="me-2" />
                  ) : null}
                  Skip
                </Button>
              </div>
            )
          )}
          <div className="text-center">
            {!isTouched ? (
              <Button
                variant="outline-danger"
                size="sm"
                onClick={() => setShowClearAttemptsConfirm(true)}
                disabled={isSubmitting || !judgePermissions?.canClear}
              >
                Clear attempts
              </Button>
            ) : (
              <Button
                variant="outline-danger"
                size="sm"
                onClick={() => {
                  setAttempts(existingAttempts);
                  setIsTouched(false);
                }}
              >
                Reset changes
              </Button>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
